import { render, staticRenderFns } from "./SwiperManagent.vue?vue&type=template&id=628c61e7"
import script from "./SwiperManagent.vue?vue&type=script&lang=js"
export * from "./SwiperManagent.vue?vue&type=script&lang=js"
import style0 from "./SwiperManagent.vue?vue&type=style&index=0&id=628c61e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports